import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import CycloneIcon from '@mui/icons-material/Cyclone';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import GarageOutlinedIcon from '@mui/icons-material/GarageOutlined';
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { AccessControlledComponents } from '~/constants';

/* NOTE: ORDER MATTERS HERE - Links will be rendered in sidebar as ordered below */
const NavLinks = [
	{
		name: 'Dashboard',
		path: 'metrics',
		icon: AssessmentOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.AdminControlTool,
	},
	{
		name: 'Control Panel',
		path: 'control-panel',
		icon: SpaceDashboardOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.DashboardPage,
	},
	{
		name: 'Facilities',
		path: 'facilities',
		icon: GarageOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.FacilitiesPage,
	},
	{
		name: 'Subscriptions',
		path: 'subscriptions',
		icon: ContactPageOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.SubscriptionsPage,
	},
	{
		name: 'Invoices',
		path: 'invoices',
		icon: DescriptionOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.InvoicesPage,
	},
	{
		name: 'Parkers',
		path: 'parkers',
		icon: DirectionsCarFilledOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.ParkersPage,
	},
	{
		name: 'Payment App',
		path: 'payment-application',
		icon: PaymentsOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.PaymentAppPage,
	},
	{
		name: 'Credits',
		path: 'credits',
		icon: SavingsOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.CreditsPage,
	},
	{
		name: 'Payments',
		path: 'payments',
		icon: PointOfSaleOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.PaymentsPage,
	},
	{
		name: 'Rates',
		path: 'rates',
		icon: LocalAtmOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.RatesPage,
	},
	{
		name: 'Reports',
		path: 'reports',
		icon: AssessmentOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.ReportsPage,
	},
	{
		name: 'Daily Reports',
		path: 'daily-reports',
		icon: EventAvailableOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.DailyReportsPage,
	},
	{
		name: 'Reservations',
		path: 'reservations',
		icon: LocalActivityOutlinedIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.ReservationsPage,
	},
	{
		name: 'Scan To Pay',
		path: 'scan-to-pay',
		icon: QrCodeIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.HourlyS2PPage,
	},
	{
		name: 'Portals',
		path: 'portals',
		icon: CycloneIcon,
		display: true,
		accessControlComponentName: AccessControlledComponents.PortalsPage,
	},
];

export default NavLinks;
